import { AbstractResourceService } from '@irian-ro/abstract-resource';
import { ETransportActions, ETransportNotificationStatusMeta } from '@well/delivery-libs/etransport/domain-model';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EtransportActionsResourceService extends AbstractResourceService<
  ETransportActions,
  null,
  ETransportNotificationStatusMeta,
  null
> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(httpClient, environmentService.getEnvironmentProperty('eTransportActionUrl'));
  }
}
